import Modal from "components/DesignSystem/Modal/Modal";
import { Combobox } from "components/DesignSystem/Combobox/Combobox";
import { Button } from "components/DesignSystem/Button/Button";
import { useState } from "react";
import { useInitiateRegistrationForStateMutation } from "store/apis/salesTaxRegistrationDetails";
import { useCurrentEntityId } from "hooks/useCurrentEntityId";
import { useCurrentGroupContext } from "hooks/useCurrentGroupContext";
import { useRoleBasedView } from "hooks/useRoleBasedView";
import { useToast } from "hooks/useToast";
import { BackendError } from "types/utils/error";
import { getBillingCartUrl } from "util/getBillingCartUrl";

export const AddRegistrationModal = ({
  open,
  onClose,
  stateOptions,
}: {
  open: boolean;
  onClose: () => void;
  stateOptions?: { label: string; value: string }[];
}) => {
  const entityId = useCurrentEntityId();
  const { uuid: groupId } = useCurrentGroupContext();
  const { isAdmin } = useRoleBasedView();
  const { alertToast } = useToast();

  const [selectedStateId, setSelectedStateId] = useState("");

  const [initiateRegistrationForState, { isLoading }] =
    useInitiateRegistrationForStateMutation();

  const handleClose = () => {
    setSelectedStateId("");
    onClose();
  };

  const handleConfirm = async () => {
    if (!selectedStateId) return;

    try {
      await initiateRegistrationForState({
        entityId,
        stateId: selectedStateId,
      }).unwrap();
      const cartUrl = getBillingCartUrl({ isAdmin, groupId, entityId });
      window.open(cartUrl, "_blank");
      handleClose();
    } catch (error) {
      alertToast({ message: (error as BackendError).data?.error?.message });
    }
  };

  return (
    <Modal.Root open={open} onOpenChange={handleClose}>
      <Modal.Content useCustomOverlay>
        <Modal.Header>
          <Modal.Title>Add Registration</Modal.Title>
          <Modal.Close />
        </Modal.Header>
        <Modal.Body>
          <Combobox
            label="State"
            placeholder="Select a state"
            options={stateOptions}
            value={
              stateOptions?.find(
                (option) => option.value === selectedStateId
              ) || null
            }
            onChange={(option) => {
              if (option instanceof Array || !option) return;
              setSelectedStateId(option.value);
            }}
            isClearable={false}
            menuPortalTarget={document.body}
          />
        </Modal.Body>
        <Modal.FooterButtonGroup>
          <Button onClick={handleClose}>Cancel</Button>
          <Button
            customType="primary"
            disabled={!selectedStateId || isLoading}
            isLoading={isLoading}
            onClick={() => void handleConfirm()}
          >
            Confirm
          </Button>
        </Modal.FooterButtonGroup>
      </Modal.Content>
    </Modal.Root>
  );
};
